"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendFlarieEmailDomain = void 0;
const appendFlarieEmailDomain = (emailPrefix) => {
    if (emailPrefix.includes('@')) {
        const [prefix] = emailPrefix.split('@');
        return `${prefix}@flarie.com`;
    }
    else {
        return `${emailPrefix}@flarie.com`;
    }
};
exports.appendFlarieEmailDomain = appendFlarieEmailDomain;
